import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PartnersSheetParsingError } from "../../../../features/brand-campaign-partners/domain/models/partners-sheet-parsing-error";

export type CampaignPartnersSheetMatchingErrorsDialogData = Readonly<
  PartnersSheetParsingError[]
>;

export type CampaignPartnersSheetMatchingErrorsDialogResult = undefined;

@Component({
  selector: "app-campaign-partners-sheet-matching-errors-dialog",
  templateUrl:
    "./campaign-partners-sheet-matching-errors-dialog.component.html",
  styleUrls: [
    "./campaign-partners-sheet-matching-errors-dialog.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPartnersSheetMatchingErrorsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly errors: CampaignPartnersSheetMatchingErrorsDialogData,
  ) {}
}
